import { connect } from 'react-redux';
import HtmlContentComponent from './html-content.component';
import * as WebViewActions from '@medscape-promo/medscapetv/web-view/web-view.actions';

const mapStateToProps = (state, ownProps) => {
	//console.log("[HtmlContent] mapStateToProps:",state);
    const props = Object.assign({
    }, {
    	"imageServer": state.WebView.medscape.config.imageServer,
        "linksTarget": state.WebView.isIframe === true ? "_blank": ""
    },ownProps)

    return props;
};
const mapDispatchToProps = dispatch => {
    return {
        onOmnitureTracking: (value,el) => {
            dispatch(WebViewActions.omnitureTracking(value,el));
        }
    }
};

const HtmlContent  = connect(mapStateToProps, mapDispatchToProps,null,{
	forwardRef: true
})(HtmlContentComponent);
export default HtmlContent;